import HomePageCategories from 'components/HomePageCategories/HomePageCategories';

export default HomePageCategories;
